import { useEffect, useState } from "react";
import { connect, useDispatch } from "react-redux";
import Modal from "../../../../../../components/Modal";
import { Formik } from "formik";
import {
  Center,
  FlexContainer,
  Separator,
} from "../../../../../../components/StyledComponents";
import {
  initialValues,
  schema,
} from "../../../../../../constants/form/event/new";
import Button from "../../../../../../components/Button";
import Submit from "../../../../../../components/Form/Submit";
import { toast } from "react-toastify";
import Input from "../../../../../../components/Form/Input";
import { hideModal } from "../../../../../../store/actions/modal";
import { newEvent, resetNewEvent } from "../../../../../../store/actions/event";
import WeekDays from "../../../../Event/components/WeekDays";
import { minInputDate } from "../../../../../../helpers/data-handler";
import ReactSelect from "../../../../../../components/Form/ReactSelect";
import TextArea from "../../../../../../components/Form/TextArea";
import { eventFrecuency } from "../../../../../../constants/events-frecuency";
import { ErrorMessage, InLine } from "../../../../../../components/Form/Field";
import Checkbox from "../../../../../../components/Form/Checkbox";
import { EntityTitleSemiBold } from "../../style";
const Component = ({
  selectedAcademy,
  updateAcademyStates,
  academies,
  current,
  newEventStates,
}) => {
  const [formSubmmited, setFormSubmmited] = useState(false);
  const [formActions, setFormActions] = useState<{ resetForm: () => void }>();
  const dispatch = useDispatch();
  const [frecuency, setFrecuency] = useState<string>();
  const onSubmit = ({ values, actions }) => {
    dispatch(newEvent({ academy: current.id, ...values }));
  };

  const closeModal = () => {
    dispatch(hideModal());
  };

  useEffect(() => {
    if (newEventStates.success) {
      toast("👌🏼 Evento Creado", {
        containerId: "submit",
        type: "success",
        toastId: "submitsucceful",
      });
      dispatch(hideModal());

      setTimeout(() => {
        dispatch(resetNewEvent());
        formActions?.resetForm();
      }, 1000);
    }

    if (newEventStates.error) {
      toast(`😱 ${newEventStates.error}`, {
        containerId: "submit",
        type: "error",
        toastId: "submiterror",
      });

      setTimeout(() => {
        dispatch(resetNewEvent());
      }, 1000);
    }
  }, [newEventStates]);

  return (
    <Modal name="create-event-cohort" title="Crear Evento">
      <Formik
        initialValues={initialValues}
        onSubmit={(values, actions) => {
          if (onSubmit) onSubmit({ values, actions });
        }}
        validateOnChange={false}
        validateOnBlur={false}
        validationSchema={schema}
        enableReinitialize
      >
        {({
          touched,
          errors,
          values,
          handleChange,
          handleBlur,
          handleSubmit,
          resetForm,
          setFieldValue,
          isSubmitting,
        }) => {
          return (
            <form
              className="theme-form"
              onSubmit={(event) => {
                setFormSubmmited(true);
                handleSubmit(event);
              }}
              id="new-event-form"
            >
              <Input
                name="name"
                error={errors["name"]}
                touched={touched["name"]}
                value={values["name"]}
                type="text"
                placeholder=""
                onChange={handleChange}
                onBlur={handleBlur}
                options={{
                  label: "Nombre del Evento",
                  marginBottom: 20,
                  skin: "gray",
                }}
              />
              <FlexContainer align="center" style={{ marginBottom: "20px" }}>
                <input
                  style={{ height: "17px", width: "17px" }}
                  name={"frecuency"}
                  checked={values["frecuency"] === "unique"}
                  onChange={() => {
                    setFieldValue(
                      "frecuency",
                      values["frecuency"] === "unique"
                        ? "personalized"
                        : "unique"
                    );
                  }}
                  type="checkbox"
                />
                <EntityTitleSemiBold>Evento Unico</EntityTitleSemiBold>
              </FlexContainer>

              {/*  <TextArea
                name="description"
                error={errors["description"]}
                touched={touched["description"]}
                value={values["description"]}
                placeholder="Ingresa una descripción de evento"
                onChange={handleChange}
                onBlur={handleBlur}
                options={{
                  label: "Descripcion",
                  marginBottom: 50,
                }}
              /> */}

              <InLine template="1fr 1fr">
                <Input
                  name="startDate"
                  error={errors["startDate"]}
                  touched={touched["startDate"]}
                  value={values["startDate"]}
                  type="date"
                  min={minInputDate()}
                  placeholder="Fecha inicio"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  options={{
                    label: "Fecha inicio",
                    marginBottom: 20,
                    skin: "gray",
                  }}
                />

                {values["frecuency"] === "personalized" && (
                  <Input
                    name="endDate"
                    error={errors["endDate"]}
                    touched={touched["endDate"]}
                    value={values["endDate"]}
                    type="date"
                    min={values["startDate"] || minInputDate()}
                    placeholder="Fecha de Cierre"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    disabled={frecuency === "unique"}
                    options={{
                      label: "Fecha Cierre",
                      marginBottom: 20,
                      skin: "gray",
                    }}
                  />
                )}
              </InLine>
              <InLine template="1fr 1fr">
                <Input
                  name="startHour"
                  error={errors["startHour"]}
                  touched={touched["startHour"]}
                  value={values["startHour"]}
                  type="time"
                  placeholder="Hora inicio"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  options={{
                    label: "Hora inicio",
                    marginBottom: 20,
                    skin: "gray",
                  }}
                />

                <Input
                  name="endHour"
                  error={errors["endHour"]}
                  touched={touched["endHour"]}
                  value={values["endHour"]}
                  type="time"
                  placeholder="Hora fin"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  options={{
                    label: "Hora fin",
                    marginBottom: 20,
                    skin: "gray",
                  }}
                />
              </InLine>
              {values["frecuency"] === "personalized" && (
                <>
                  <WeekDays
                    setValue={(value) => {
                      if (values.eventDays.includes(value)) {
                        setFieldValue(
                          "eventDays",
                          values.eventDays.filter((event) => event !== value)
                        );
                      } else {
                        setFieldValue("eventDays", [
                          ...values.eventDays,
                          value,
                        ]);
                      }
                    }}
                    error={errors["eventDays"]}
                    touched={touched["eventDays"]}
                    value={values["eventDays"]}
                    onChange={handleChange}
                    onBlur={handleBlur}
                  />
                  {errors.eventDays && (
                    <ErrorMessage>{errors.eventDays}</ErrorMessage>
                  )}
                  <Separator size={10}></Separator>
                </>
              )}

              <Input
                name="meetLink"
                error={errors["meetLink"]}
                touched={touched["meetLink"]}
                value={values["meetLink"]}
                type="text"
                placeholder=""
                onChange={handleChange}
                onBlur={handleBlur}
                options={{
                  label: "Link del Evento",
                  marginBottom: 40,
                  skin: "gray",
                }}
              />

              <Center>
                <Submit
                  isSubmmiting={newEventStates.loading}
                  form="new-event-form"
                  color="Primary"
                  options={{
                    type: "filled",
                    skin: "primary",
                    size: "lg",
                    marginBottom: "0px",
                  }}
                >
                  Confirmar
                </Submit>
                <Button
                  onClick={closeModal}
                  type="button"
                  options={{
                    type: "outline",
                    skin: "danger",
                    size: "lg",
                    marginBottom: "0px",
                  }}
                  style={{ marginLeft: "10px" }}
                >
                  Cancelar
                </Button>
              </Center>
            </form>
          );
        }}
      </Formik>
    </Modal>
  );
};

const states = ({ academyStore, currentStore, eventStore }) => {
  const { data: selectedAcademy } = academyStore.selected;
  const { states: updateAcademyStates } = academyStore.update;
  const { data: current } = currentStore;
  const { data: academies } = academyStore.all;
  const { states: newEventStates } = eventStore.newEvent;
  const { states: updateEventStates } = eventStore.updateEvent;
  return {
    selectedAcademy,
    updateAcademyStates,
    academies,
    newEventStates,
    current,
  };
};

export default connect(states)(Component);
